import { LoadingSpinner } from "@/components/loading/LoadingSpinner";
import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import PriceMarkdownRoutes from "@/pages/business-planning/price-markdown/price-markdown.routes";
import { FileText, LayoutGrid, ListChecks, Wallet } from "lucide-react";
import { lazy, Suspense } from "react";

import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";

// eslint-disable-next-line react-refresh/only-export-components
const PriceMarkdownSelecaoPage = lazy(
  () => import("@/pages/business-planning/price-markdown/selection"),
);
// eslint-disable-next-line react-refresh/only-export-components
const LettersListPage = lazy(
  () => import("@/pages/business-planning/price-markdown/letters"),
);
// eslint-disable-next-line react-refresh/only-export-components
const VerbaFamiliaMensalAdminPage = lazy(
  () => import("@/pages/business-planning/price-markdown/budget"),
);

const isPriceMarkdownEnabled = import.meta.env.VITE_PRICE_MARKDOWN_ENABLED === "true";

const buildRemarcacaoDePrecoRoutes = () => {
  if (!isPriceMarkdownEnabled) {
    return [];
  }
  return [
    createRoute({
      id: "Visão Geral",
      category: GroupsEnum.REMARCACAO_DE_PRECO,
      requiredRole: [RoleEnum.USER, RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
      groupRequired: [GroupsEnum.REMARCACAO_DE_PRECO],
      path: "/*",
      pathId: PATH_IDS.REMARCACAO_DE_PRECO,
      element: <PriceMarkdownRoutes />,
      Icon: LayoutGrid,
    }),
    createRoute({
      id: "Remarcações",
      category: GroupsEnum.REMARCACAO_DE_PRECO,
      requiredRole: [RoleEnum.USER, RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
      groupRequired: [GroupsEnum.REMARCACAO_DE_PRECO],
      path: "/selecao",
      pathId: PATH_IDS.REMARCACAO_DE_PRECO,
      element: (
        <Suspense fallback={<LoadingSpinner />}>
          <PriceMarkdownSelecaoPage />
        </Suspense>
      ),
      Icon: ListChecks,
    }),
    createRoute({
      id: "Cartas",
      category: GroupsEnum.REMARCACAO_DE_PRECO,
      requiredRole: [RoleEnum.ADMINISTRADOR],
      groupRequired: [GroupsEnum.REMARCACAO_DE_PRECO],
      path: "/cartas",
      pathId: PATH_IDS.REMARCACAO_DE_PRECO,
      element: (
        <Suspense fallback={<LoadingSpinner />}>
          <LettersListPage />
        </Suspense>
      ),
      Icon: FileText,
    }),
    createRoute({
      id: "Verba e Teto",
      category: GroupsEnum.REMARCACAO_DE_PRECO,
      requiredRole: [RoleEnum.ADMINISTRADOR],
      groupRequired: [GroupsEnum.REMARCACAO_DE_PRECO],
      path: "/verba",
      pathId: PATH_IDS.REMARCACAO_DE_PRECO,
      element: (
        <Suspense fallback={<LoadingSpinner />}>
          <VerbaFamiliaMensalAdminPage />
        </Suspense>
      ),
      Icon: Wallet,
    }),
  ];
};

export const remarcacaoDePrecoRoutes = buildRemarcacaoDePrecoRoutes();
